/*Note: Down below may be bad practice/hard coding, but until I find a more optimal 
solution, this will have to suffice. */

import { windowHeight, windowWidth } from "./App.js";

// The Forward variables
let x = 13; // number of pages in book
let r = 0, z = -2; // r = position of page to the right, z = z-index

// The Backward Variables (Hiding for experiment)
//let y = -14;
//let r2 = -26, z2 = 12;

let RightPage = NaN; 
let LeftPage = NaN;
let FrontCover = NaN;
let BackCover = NaN;
let OpenBookCover = NaN;
let BookPages = NaN;
let PageContent = NaN;

// Experiment: using same Child Number variable
let ChildValue = 0;  // This variable will store the numeric value of the nth child we will call and then change.

setTimeout(() => {
    console.debug("Width of window (pageanims): " + windowWidth);
    console.debug("Height of window (pageanims): " + windowHeight);
}, 10);

export function ForwardFlipCSS(Pagenums) {
    console.debug("---------------------: ","\n\n");

    // console.debug("Initial Value of X: " + x);
     console.debug("Value of r for right: " + r);
    //console.debug("Value of z Index: " + z);


    /*Receiving the element that contains the actual book pages, in order to manipulate their
    CSS properties to create the page animations.*/
    const PageChildrenRight = document.querySelectorAll("ul > li");
    PageContent = document.getElementById("BoA-page-content");


    //console.debug("Value of ChildValue before (in ForwardFlip): " + ChildValue);

    // If user reaches page one, always reset to default CSS and page values.
    if (Pagenums === 1) {
        x = 13;
        r = 0;
        z = -2;
        console.debug("X after: " + x);
       // ChildValue = (Pagenums) + (x) - 1; 
    }
    x -= 2; // decrement x by 2
    r -= 2; // decrement right index
    z++; // Increment z-index.

    ChildValue = (Pagenums) + (x) + 1;       

    // console.debug("X after: " + x);
    console.debug("Value of ChildValue after (in ForwardFlip): " + ChildValue);
    console.debug("Value of r after: " + r);
    // console.debug("Value of z after: " + z);

  //  console.debug("X after (outside condition): " + x);

    //console.debug("Does PageChildren return a value? " + PageChildrenRight);

    /* Manipulating each page by changing its position (right), depth (z-index), and rotation
    across the book. */
    RightPage = PageChildrenRight[ChildValue];
    if (RightPage === undefined) {
        console.debug("Value of RightPage: " + RightPage);
    } else if (PageContent === null) {
        console.debug("Value of PageContent: " + PageContent);
    } else {
        // New experiment 10/27/24: invoking JS animate function (Experiment WORKS!)
            
        PageContent.style.zIndex = z;
        PageContent.animate(
            [
                { opacity: "1" },
                { opacity: "0.0" },
                { opacity: "0.0" },
                { opacity: "0.0" },
                { opacity: "0.0" },
                { opacity: "0.15" },
                { opacity: "0.25" },
                { opacity: "0.5" },
                { opacity: "0.75" },
                { opacity: "1" }

            ], 
                { duration: 3000,
                easing: "cubic-bezier(.5,.33,.18,1)",
                fill: "backwards"
                }
            ); 

        if (windowWidth >= 1536 && windowHeight >= 900) {
            console.debug("Widescreen true");
            RightPage.animate(
                [
                    { transform: "rotateY(0deg)", right: "auto" },
                    { transform: "rotateY(180deg)", right: r * 0.5 + "px", zIndex: z }
                ],
                    { duration: 800,
                    easing: "cubic-bezier(.77,0,.18,1)",
                    fill: "forwards"
                    }
                );
        } else if ((windowWidth >= 768 && windowWidth < 1536) 
            || (windowWidth >= 1536 && windowHeight <= 900)) {
            // If the width is greater than 768 but less than 1280, multiply r by 0.3.  
            console.debug("0.3 is true.");
            RightPage.animate(
                [
                    { transform: "rotateY(0deg)", right: "auto" },
                    { transform: "rotateY(180deg)", right: r * 0.3 + "px", zIndex: z }
                ],
                    { duration: 800,
                    easing: "cubic-bezier(.77,0,.18,1)",
                    fill: "forwards"
                    }
                );
            } else if (windowWidth < 768) {
                 // If the width is less than 768, multiply r by 0.25. 
                console.debug("0.25 is true."); 
                RightPage.animate(
                    [
                        { transform: "rotateY(0deg)", right: "auto" },
                        { transform: "rotateY(180deg)", right: r * 0.25 + "px", zIndex: z }
                    ],
                        { duration: 800,
                        easing: "cubic-bezier(.77,0,.18,1)",
                        fill: "forwards"
                        }
                );
         }
    }
}

export function BackwardFlipCSS(Pagenums) {
    console.debug("---------------------: ","\n\n");

    //let ChildValue = 14; 
    const PageChildrenLeft = document.querySelectorAll("ul > li");
    PageContent = document.getElementById("BoA-page-content");

   // console.debug("Value of ChildValue before (in BackwardFlip): " + ChildValue);

    // console.debug("Initial Value of x (backward) = " + x);
    // console.debug("Value of r for right (backward): " + r);
     console.debug("Value of z Index (backward): " + z);

    // If user reaches final page, always reset X to its final page value.
    if (Pagenums === 14) {
        x = -17;
        r = -30;
        z = 13;
        console.debug("X after: " + x);
        console.debug("R after: " + r);
        console.debug("Z after: " + z);
        // ChildValue = (Pagenums) + (x) - 1; 
    }
    
    ChildValue = (Pagenums) + (x) + 2;       
    x += 2; // increment x by 2
    r += 2;
    z--;

    // console.debug("Final Values (backward): x = " + x);

    console.debug("Value of ChildValue after (in BackwardFlip): " + ChildValue);
    // console.debug("Value of r after (back): " + r);
    // console.debug("Value of z after (back): " + z);

    LeftPage = PageChildrenLeft[ChildValue];
    
    if (LeftPage === undefined) {
        console.debug("Value of LeftPage: " + LeftPage);
    } else if (PageContent === null) {
        console.debug("Value of PageContent: " + PageContent);
    } else {
        // Experiment: also trying on flipping page backwards 
       // PageContent.style.zIndex = z;
        PageContent.animate(
            [
                { opacity: "1" },
                { opacity: "0.5" },
                { opacity: "0.25" },
                { opacity: "0.0" },
                { opacity: "0.0" },
                { opacity: "0.0" },
                { opacity: "0.0" },
                { opacity: "0.0" },
                { opacity: "0.0" },
                { opacity: "0.0" }

            ], 
                { duration: 3000,
                easing: "cubic-bezier(.15,.33,.18,1)",
                fill: "backwards"
                }
            ); 
       
            if (windowWidth >= 1536 && windowHeight >= 900) {
                LeftPage.animate(
                    [
                        { transform: "rotateY(180deg)", right: r * 0.5 + "px" },
                        { transform: "rotateY(0deg)", right: "auto", zIndex: "auto" }
                    ],
                        { duration: 800,
                        easing: "cubic-bezier(.77,0,.18,1)",
                        fill: "forwards"
                        }
                    );
            } else if ((windowWidth >= 768 && windowWidth < 1536) 
                || (windowWidth >= 1536 && windowHeight <= 900)) {
            // If the width is greater than 768 but less than 1280, multiply r by 0.3. 
                console.debug("0.3 is true (back).");
                LeftPage.animate(
                    [
                        { transform: "rotateY(180deg)", right: r * 0.3 + "px" },
                        { transform: "rotateY(0deg)", right: "auto", zIndex: "auto" }
                    ],
                        { duration: 800,
                        easing: "cubic-bezier(.77,0,.18,1)",
                        fill: "forwards"
                        }
                    );
            } else if (windowWidth < 768) {
                 // If the width is less than 768, multiply r by 0.25. 
                console.debug("0.25 is true.");
                LeftPage.animate(
                    [
                        { transform: "rotateY(180deg)", right: r * 0.25 + "px" },
                        { transform: "rotateY(0deg)", right: "auto", zIndex: "auto" }
                    ],
                        { duration: 800,
                        easing: "cubic-bezier(.77,0,.18,1)",
                        fill: "forwards"
                        }
                    );
          }
    }
}

export function HeaderPosition(HeaderElement, Pagenums) {
    FrontCover = document.getElementById("BoA-book-cover-front");
    BackCover = document.getElementById("BoA-book-cover-back");
    OpenBookCover = document.getElementById("BoA-book-cover-open");
    BookPages = document.getElementById("BoA-background-pages");
    PageContent = document.getElementById("BoA-page-content");

    console.debug("Testing HeaderElement in HeaderPosition: " + HeaderElement);
    console.debug("Testing Pagenums in HeaderPosition: " + Pagenums);

    /*Convert to Switch later (done as of 10/30/24 1:25 PM) */
    switch(HeaderElement) {
        case "BoA-header-artwork": 
            ChildValue = 11;
            x = 7;
            r = -6;
            z = 1;
            break;
        case "BoA-header-coding-projects":
            ChildValue = 8;
            x = 1;
            r = -12;
            z = 4;
            break;
        case "BoA-header-writing":
            ChildValue = 3;
            x = -9;
            r = -22;
            z = 9;
            break;
        case "BoA-header-about":
            ChildValue = 2;
            x = -11;
            r = -24;
            z = 10;
            break;
        default:
            ChildValue = 0;
            x = 13;
            r = 0;
            z = -2;
            break;
    }
    if (FrontCover !== null && Pagenums === 0 && 
        (HeaderElement !== "BoA-footer-logo") && 
        (HeaderElement !== "BoA-header-logo")) { // Choosing a chapter from the home page/front cover.
        console.debug("Does it work here?");
        FrontCover.animate(
            [
                { transform: "rotateY(0deg)", opacity: "1" },
                { transform: "rotateY(75deg)", opacity: "0.0" }
            ], 
                { duration: 500,
                    easing: "cubic-bezier(.77,0,.18,1)",
                    fill: "forwards"
                }
        );
        OpenBookCover.animate(
            [
                { transform: "rotateY(90deg)", opacity: "0.25" },
                { transform: "rotateY(0deg)", opacity: "1" }

            ], 
                { duration: 1000,
                easing: "cubic-bezier(.77,0,.18,1)",
                fill: "forwards"
                }
        );  
    } else if (BackCover !== null && Pagenums === 15 &&
        (HeaderElement !== "BoA-footer-logo") && 
        (HeaderElement !== "BoA-header-logo")) {  // Choosing a chapter from the back cover.
        BackCover.animate(
            [
                { transform: "rotateY(0deg)", opacity: "1" },
                { transform: "rotateY(75deg)", opacity: "0.0" }
            ], 
                { duration: 500,
                easing: "cubic-bezier(.77,0,.18,1)",
                fill: "forwards"
                }
        );
        OpenBookCover.animate(
            [
                { transform: "rotateY(90deg)", opacity: "0.25" },
                { transform: "rotateY(0deg)", opacity: "1" }
            ], 
                { duration: 1000,
                easing: "cubic-bezier(.77,0,.18,1)",
                fill: "forwards"
                }
        ); 
    } else if (HeaderElement === "BoA-header-logo" && PageContent !== null) { // Clicking to go to front cover anywhere
        PageContent.animate(
            [
                { opacity: "1" },
                { opacity: "0.0" }
            ], 
                { duration: 500,
                easing: "cubic-bezier(.77,0,.18,1)",
                fill: "forwards"
                }
        ); 
        BookPages.animate(
            [
                { opacity: "1" },
                { opacity: "0.0" }
            ], 
                { duration: 500,
                easing: "cubic-bezier(.77,0,.18,1)",
                fill: "forwards"
                }
        );   
        OpenBookCover.animate(
            [
                { transform: "rotateY(0deg)", opacity: "1" },
                { transform: "rotateY(75deg)", opacity: "0.15" }
            ], 
                { duration: 1000,
                easing: "cubic-bezier(.77,0,.18,1)",
                fill: "forwards"
                }
        );
        FrontCover.animate(
            [
                { transform: "rotateY(75deg)", opacity: "0.0" },
                { transform: "rotateY(0deg)", opacity: "1" }
            ], 
                { duration: 1500,
                easing: "cubic-bezier(.77,0,.18,1)",
                fill: "forwards"
                }
            );
    } else if (HeaderElement === "BoA-footer-logo" && PageContent !== null) { // Clicking to go to back cover anywhere
        console.debug("Footer true");
        PageContent.animate(
            [
                { opacity: "1" },
                { opacity: "0.0" }

            ], 
                { duration: 500,
                easing: "cubic-bezier(.77,0,.18,1)",
                fill: "forwards"
                }
        ); 
        BookPages.animate(
            [
                { opacity: "1" },
                { opacity: "0.0" }
            ], 
                { duration: 500,
                easing: "cubic-bezier(.77,0,.18,1)",
                fill: "forwards"
                }
        );   
        OpenBookCover.animate(
            [
                { transform: "rotateY(0deg)", opacity: "1" },
                { transform: "rotateY(75deg)", opacity: "0.15" }

            ], 
                { duration: 1000,
                easing: "cubic-bezier(.77,0,.18,1)",
                fill: "forwards"
                }
        );
        BackCover.animate(
            [
                { transform: "rotateY(75deg)", opacity: "0.0" },
                { transform: "rotateY(0deg)", opacity: "1" }
            ], 
                { duration: 1500,
                    easing: "cubic-bezier(.77,0,.18,1)",
                    fill: "forwards"
                }
        );
    } else if ((HeaderElement === "BoA-header-logo") && (FrontCover !== null)
        && (PageContent === null) && (Pagenums === 0)) { // Clicking the header logo repeatedly
        console.debug("True AF");
        FrontCover.animate(
            [
                { transform: "rotateY(0deg)" },
                { transform: "rotateY(180deg)" },
                { transform: "rotateY(360deg)" }

            ], 
                { duration: 500,
                    easing: "cubic-bezier(.77,0,.18,1)",
                    fill: "forwards"
                }
        );
    } else if ((HeaderElement === "BoA-footer-logo") && (BackCover !== null)
        && (PageContent === null) && (Pagenums === 15)) { // Clicking the footer logo repeatedly
        console.debug("Also True AF");
        BackCover.animate(
            [
                { transform: "rotateY(0deg)" },
                { transform: "rotateY(180deg)" },
                { transform: "rotateY(360deg)" }

            ], 
                { duration: 500,
                    easing: "cubic-bezier(.77,0,.18,1)",
                    fill: "forwards"
                }
        );
    } else if ((Pagenums === 1 || Pagenums === 14) && 
        (FrontCover !== null) && (BackCover !== null)) {
        BookPages.animate(
            [
                { opacity: "1", filter: "blur(0px)" },
                { opacity: "0.5", filter: "blur(5px)" },
                { opacity: "0.0", filter: "blur(10px)" }
            ],
                { duration: 1000,
                easing: "cubic-bezier(.77,0,.18,1)",
                fill: "forwards"
                }
        );          
    } else if (HeaderElement === "BoA-footer-logo") {
        FrontCover.animate(
            [
                { transform: "rotateY(0deg)", opacity: "1.0" },
                { transform: "rotateY(180deg)", opacity: "0.0" }
            ], 
                { duration: 500,
                easing: "cubic-bezier(.77,0,.18,1)",
                fill: "forwards"
                }
        );
        BackCover.animate(
            [
                { transform: "rotateY(180deg)", opacity: "0.0" },
                { transform: "rotateY(0deg)", opacity: "1.0"}
            ], 
                { duration: 500,
                    easing: "cubic-bezier(.77,0,.18,1)",
                    fill: "forwards"
                }
        );
    } else if (HeaderElement === "BoA-header-logo") {
        BackCover.animate(
            [
                { transform: "rotateY(0deg)", opacity: "1.0" },
                { transform: "rotateY(180deg)", opacity: "0.0"}
            ], 
                { duration: 500,
                    easing: "cubic-bezier(.77,0,.18,1)",
                    fill: "forwards"
                }
        );
        FrontCover.animate(
            [
                { transform: "rotateY(180deg)", opacity: "0.0" },
                { transform: "rotateY(0deg)", opacity: "1.0" }
            ], 
                { duration: 500,
                easing: "cubic-bezier(.77,0,.18,1)",
                fill: "forwards"
                }
        );
    } else {
        console.debug("True default");
        PageContent.animate(
            [
                { opacity: "1", filter: "blur(0px)" },
                { opacity: "0.5", filter: "blur(5px)" },
                { opacity: "0.0", filter: "blur(10px)" }
            ], 
                { duration: 1000,
                easing: "cubic-bezier(.77,0,.18,1)",
                fill: "forwards"
                }
        );
        BookPages.animate(
            [
                { opacity: "1", filter: "blur(0px)" },
                { opacity: "0.5", filter: "blur(5px)" },
                { opacity: "0.0", filter: "blur(10px)" }
            ],
                { duration: 1000,
                easing: "cubic-bezier(.77,0,.18,1)",
                fill: "forwards"
                }
        );         
    }
}

export function CoverAnimation(Pagenums) {
    FrontCover = document.getElementById("BoA-book-cover-front");
    BackCover = document.getElementById("BoA-book-cover-back");
    OpenBookCover = document.getElementById("BoA-book-cover-open");
    BookPages = document.getElementById("BoA-background-pages");

    console.debug("Cover animation?");
    console.debug("Pagenums: " + Pagenums);

    /* Closing the book from the frontpage. */
    if (Pagenums === 0) {
        BookPages.animate(
            [
                { opacity: "1" },
                { opacity: "0.0" }

            ], 
                { duration: 500,
                easing: "cubic-bezier(.77,0,.18,1)",
                fill: "forwards"
                }
        );   

        OpenBookCover.animate(
            [
                { transform: "rotateY(0deg)", opacity: "1" },
                { transform: "rotateY(75deg)", opacity: "0.15" }

            ], 
                { duration: 1000,
                easing: "cubic-bezier(.77,0,.18,1)",
                fill: "forwards"
                }
        );

        FrontCover.animate(
            [
                { transform: "rotateY(75deg)", opacity: "0.0" },
                { transform: "rotateY(0deg)", opacity: "1" }
            ], 
                { duration: 1500,
                    easing: "cubic-bezier(.77,0,.18,1)",
                    fill: "forwards"
                }
            );

    /* Opening the book to reach the frontpage. */
    } else if (Pagenums === 1) {
        console.debug("BookPages Null? " + BookPages);
        FrontCover.animate(
            [
                { transform: "rotateY(0deg)", opacity: "1" },
                { transform: "rotateY(75deg)", opacity: "0.0" }
            ], 
                { duration: 500,
                    easing: "cubic-bezier(.77,0,.18,1)",
                    fill: "forwards"
                }
            );
            
        OpenBookCover.animate(
            [
                { transform: "rotateY(90deg)", opacity: "0.0" },
                { transform: "rotateY(0deg)", opacity: "1" }

            ], 
                { duration: 1000,
                easing: "cubic-bezier(.77,0,.18,1)",
                fill: "forwards"
                }
        );  

        BookPages.animate(
            [
                { opacity: "0.0" },
                { opacity: "1" }

            ], 
                { duration: 1500,
                easing: "cubic-bezier(.77,0,.18,1)",
                fill: "forwards"
                }
        ); 

        /*Opening the book from the back cover. */
    } else if (Pagenums === 14) {
        BackCover.animate(
            [
                { transform: "rotateY(0deg)", opacity: "1" },
                { transform: "rotateY(75deg)", opacity: "0.0" }
            ], 
                { duration: 500,
                    easing: "cubic-bezier(.77,0,.18,1)",
                    fill: "forwards"
                }
        );

        OpenBookCover.animate(
                [
                    { transform: "rotateY(90deg)", opacity: "0.25" },
                    { transform: "rotateY(0deg)", opacity: "1" }
    
                ], 
                    { duration: 1000,
                    easing: "cubic-bezier(.77,0,.18,1)",
                    fill: "forwards"
                    }
        );  

        BookPages.animate(
                [
                    { opacity: "0.0" },
                    { opacity: "1" }
    
                ], 
                    { duration: 1500,
                    easing: "cubic-bezier(.77,0,.18,1)",
                    fill: "forwards"
                    }
        ); 
        /*Closing the book to reach the back cover. */
    } else if (Pagenums === 15) {

        BookPages.animate(
            [
                { opacity: "1" },
                { opacity: "0.0" }

            ], 
                { duration: 500,
                easing: "cubic-bezier(.77,0,.18,1)",
                fill: "forwards"
                }
        );  

        OpenBookCover.animate(
            [
                { transform: "rotateY(0deg)", opacity: "1" },
                { transform: "rotateY(-75deg)", opacity: "0.15" }

            ], 
                { duration: 1000,
                easing: "cubic-bezier(.77,0,.18,1)",
                fill: "forwards"
                }
        );

        BackCover.animate(
            [
                { transform: "rotateY(75deg)", opacity: "0.0" },
                { transform: "rotateY(0deg)", opacity: "1" }
            ], 
                { duration: 1500,
                    easing: "cubic-bezier(.77,0,.18,1)",
                    fill: "forwards"
                }
        );
    }
}




/**OLD SOURCE CODE AND NOTES BELOW */

/* EXPERIMENT: Let's see if the pages will flip with any value of Pagenums
    when called in their respective functions.
    if (Pagenums === 7) {
        ChildValue = Pagenums;
        x -= 2; // decrement x by 2
       // console.debug("X when Pagenums = 7: " + x);
        r -= 2;
        z++; 
        console.debug("Value of ChildValue (7): " + ChildValue);

    } else if (Pagenums === 13) {
        ChildValue = 1; // Only way I could keep ChildValue intact.
        r -= 2;
        z = 10; 
       // console.debug("X when Pagenums = 13: " + x);
    } else {
        //console.debug("X before ChildValue: " + x);
        ChildValue = (Pagenums) + (x) + 1;       
       // console.debug("X after ChildValue: " + x);
    }*/

       /* EXPERIMENT: Let's see if the pages will flip with any value of Pagenums
    when called in their respective functions.

    if (Pagenums === 13) {
        console.debug("Value of ChildValue when Pagenums = 13: " + ChildValue);
        console.debug("Y when Pagenums = 13: " + y);

        ChildValue = (Pagenums) + (y) + 1; 
        console.debug("New Value of ChildValue after added: " + ChildValue);
        console.debug("Y before increment: " + y);

        y += 4; // decrement x by 2
        console.debug("Y after increment: " + y);

        r += 4;
        z2-=2; 

    } else {
        ChildValue = (Pagenums) + (y) + 1; 
    } /*else if (Pagenums === 7) {
        ChildValue = 1; // Only way I could keep ChildValue intact.
        r -= 2;
        z = 10; 
       // console.debug("X when Pagenums = 13: " + x);
    } else {
        //console.debug("X before ChildValue: " + x);
        ChildValue = (Pagenums) + (x) + 1;       
       // console.debug("X after ChildValue: " + x);
    } 
       

     function ForwardSecFlip() {

    const PageChildrenRight = document.querySelectorAll("ul > li");
  
    if (location.pathname == "/tableofcontents") {
        RightPage = PageChildrenRight[13];
        RightPage.style.right = "-4px";
        RightPage.style.transform = "rotateY(180deg)";
    }
  
   }
   
   
   
   
   
   function BackwardSecFlip() {
   }
   
 export function ForwardSecFlip(Pagenums) {
//     const PageChildrenRight = document.querySelectorAll("ul > li");

//     console.debug("Pagenums in function: " + Pagenums);

//     if (Pagenums === 2) {

//         RightPage = PageChildrenRight[12];
//         RightPage.style.right = "-4px";
//         RightPage.style.transform = "rotateY(180deg)";
        
//      } 
//     return URLSwitch;
// }

    
    
     Old RightPage style code + CSS Keyframe code inspiring this

        Converting from CSS keyframes code: 
          animation: pageflip 0.8s cubic-bezier(.77,0,.18,1) forwards;
                    }

            @keyframes pageflip {
            0% {
                transform: rotateY(0deg);
                right: auto;
            } 100% {
                transform: rotateY(180deg);
                right: -14px;
                z-index: 5;
            }

        RightPage.animate(
        [
            { transform: "rotateY(0deg)", right: "auto" },
            { transform: "rotateY(180deg)", right: r + "px", zIndex: 5 }
        ],
            { duration: 800,
             easing: cubic-bezier(.77,0,.18,1),
             fill: forwards
            }
        );

        
        RightPage.style.right = r + "px";
        RightPage.style.zIndex = z;
        RightPage.style.transform = "rotateY(180deg)";
                
        LeftPage.style.right="auto";
        LeftPage.style.zIndex="auto";
        LeftPage.style.transform = "rotateY(0deg)";
        
    
    */